// extracted by mini-css-extract-plugin
module.exports = {"noShadowLink":"LinkBox_noShadowLink__cH60_"};